import { User, UserRequest } from '@dynamika-shared/types/users';
import { DefaultOptionType } from 'antd/lib/select';
import { getCountryDataList } from 'countries-list';
import get from 'lodash/get';

export const convertUserToUserRequest = (user: User): UserRequest => {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    roles: user.roles,
    country: user.country,
    organizationId: user.organizationId,
    phone: user.phone,
  };
};

export const filterOptionHandler =
  (valuePath = 'label', cb?: (s: string) => void) =>
  (input: string, option: DefaultOptionType | undefined) => {
    cb && cb(input);
    return (get(option, valuePath, '') as string)
      .toLowerCase()
      .includes(input.toLowerCase());
  };

export const countryOptions = getCountryDataList()
  .map(country => ({
    label: country.name,
    value: country.name,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
